import type { FaireProductEntity } from "../../entity_types/product";

export const p_ndbuw94d2j: FaireProductEntity = {
  token: "p_ndbuw94d2j",
  type: "product",
  name: "PERFY SODA SF TROPICAL CITRUS - Case of 12",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/3c85793e732d711fcc2f032814085176382f6682db866e8f579a008d7d3ae899.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0b1e52c8a6676f9e19b13a520ac18471ef26f7c28c3add0954a27236d42c2eb.jpeg",
    "https://cdn.faire.com/fastly/c98bb43f7064e60081427c292e7cbb3c453c4c1690caad1500f7e83ffce8d5a9.jpeg",
  ],
  priceDollars: 55.21,
  description:
    "A delicious, low glycemic blend of not from concentrate passion fruit, pineapple, lemon, guava, and blood orange juices. Each can of Tropical Citrus has 4g sugar, 4g net carbs, 20 calories, and is enhanced with 50mg L-Theanine and 30mg of Turmeric. Caffeine-free and Gluten-free. Vegan and made from non-GMO ingredients.\n",
  tags: [],
  msrpDollars: 110.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:13.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
